import React, { useState } from 'react';
import Select from 'react-select';
import emailjs from 'emailjs-com';
import computer from '../../assests/service/doctors-shaking-hands.jpg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const countryOptions = [
  { value: 'IA', label: 'India' },
  { value: 'CA', label: 'Canada' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
];

function Frame7() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    companyName: '',
    message: ''
  });
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };
  const isFormValid = () => {
    return (
      formData.firstName.trim() &&
      formData.lastName.trim() &&
      formData.email.trim() &&
      formData.phoneNumber.trim() &&
      formData.companyName.trim() &&
      formData.message.trim() &&
      selectedCountry
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // if (!formData.email || !formData.firstName || !formData.lastName) {
    //   alert("Please fill in all required fields.");
    //   return;
    // }
    if (!isFormValid()) {
      toast.error("Please fill in all fields before submitting.");
      return;
    }
    setLoading(true);
    const templateParams = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      companyName: formData.companyName,
      country: selectedCountry ? selectedCountry.label : "Not specified",
      message: formData.message,
    };

    emailjs
      .send(
        "service_ezjdods", // Replace with your EmailJS service ID
        "template_vrc6jok", // Replace with your EmailJS template ID
        templateParams,
        "GS_nkaKrv3f-icNDp" // Replace with your EmailJS public key
      )
      .then(
        (response) => {
          setLoading(false);
          toast.success("Mail sent successfully!");
          // alert("Mail sent successfully!");
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            companyName: "",
            message: "",
          });
          setSelectedCountry(null);
        },
        (error) => {
          setLoading(false);
          toast.error("Failed to send email.");
          // alert("Failed to send email.");
        }
      );
  };
  return (
    <div className="w-full mx-auto m-5">
      <ToastContainer />
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col lg:flex-row lg:justify-between p-5  lg:p-10 w-full">
          <div className="rounded-3xl lg:mr-8 sm:mr-0 mb-8 lg:mb-0">
            <div className="text-start font-[Poppins] mb-6 font-semibold text-medium tracking-wide leading-loose text-black">
              Seamless Healthcare Integration with <span className='text-[#2a627a] font-extrabold  leading-tight text-2xl '> HIKEHEALTH GS</span>
            </div>
            <div
              className="relative bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${computer})`, height: '200px', width: "100%", backgroundSize: "cover", backgroundPosition: "center" }}
            />

            <div>
              <h2 className="text-start font-bold mt-10 text-[20px]">
                What You Get with HIKEHEALTH GS Integration
              </h2>
              <div className="text-start mt-5 text-[15px] font-[Poppins]">
                <li className="mb-1">Fast and secure EHR/EMR integration within 12 hours.</li>
                <li className="mb-1">Comprehensive action plan for seamless data exchange.</li>
                <li className="mb-1">Interoperability solutions that meet industry standards.</li>
                <li className="mb-1">Access to expert guidance and healthcare compliance resources.</li>
              </div>
            </div>
          </div>


          <div className="border rounded-lg border-[#2a627a] text-start bg-gray-300 p-4  flex flex-col w-full lg:w-1/2">
            <div className="mb-4 font-semibold text-xl tracking-wide leading-loose text-[#2a627a] font-[Poppins]">
              Contact us
            </div>
            <div className="mb-6 font-normal text-sm tracking-wide leading-loose text-black font-[Poppins]">
              Enter your contact details below and we will reach out to you by <br /> next business day
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col">
                <label htmlFor="firstName" className="font-medium text-sm text-black">First name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  className="border rounded-md p-2 mt-1 focus:outline-none w-full"
                  value={formData.firstName}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="lastName" className="font-medium text-sm text-black">Last name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  className="border rounded-md p-2 mt-1 focus:outline-none w-full"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="email" className="font-medium text-sm text-black">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="border rounded-md p-2 mt-1 focus:outline-none w-full"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col overflow-hidden">
                <label htmlFor="phoneNumber" className="font-medium text-sm text-black">
                  Phone number
                </label>
                <input
                  type="text" // Use text input to allow validation
                  id="phoneNumber"
                  name="phoneNumber"
                  className="border rounded-md p-2 mt-1 focus:outline-none w-full"
                  value={formData.phoneNumber}
                  maxLength="10" // Limit the maximum length to 10 digits
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="companyName" className="font-medium text-sm text-black">Company name</label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  className="border rounded-md p-2 mt-1 focus:outline-none w-full"
                  value={formData.companyName}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="country" className="font-medium text-sm text-black mb-2">Country</label>
                <Select
                  id="country"
                  name="country"
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  options={countryOptions}
                  className="basic-single"
                  classNamePrefix="select"
                />
              </div>
            </div>
            <div className="flex flex-col mt-2">
              <label htmlFor="message" className="font-medium text-sm text-black">What you need?</label>
              <textarea
                id="message"
                name="message"
                rows="3"
                className="border rounded-md p-2 mt-1 focus:outline-none w-full resize-none"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <div className="flex justify-start mt-4">
              <button
                type="submit"
                className={`py-2 px-4 rounded-lg leading-loose focus:outline-none ${isFormValid() ? "bg-[#2a627a] text-white" : "bg-gray-400 text-gray-700 cursor-not-allowed"
                  }`}
                disabled={!isFormValid() || loading}
              >
                {loading ? "Sending..." : "Send"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Frame7;


